import { ErrorMessage, errorMessagesSection, faExclamationCircle, FontAwesomeIcon, FormStyle,
         infoPlaceholderSection, React, Select, SelectStyle, components, InputError, TRANSLATION } from "@/imports-files/components/custom-select";

import CustomDropdownArrowIcon from 'public/new-icons/arrow-solid.svg';

export function CustomSelect(props)
{
  let defaultClass = props.career ? props.career :  `${SelectStyle.Form__CustomSelect} ${FormStyle.Form__CustomSelect}`
  let currency_present = props.isCurrency ? SelectStyle.Form__select_currency : '';


   const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CustomDropdownArrowIcon />
      </components.DropdownIndicator>
    );
  };

    return(
            <div className= {currency_present}>
              { props.isCurrency && <span className = {`${SelectStyle.Form__currency_symbol} ${FormStyle.Form__currency_symbol} ${props.currencyClass}`}  style={InputError(props.formik, 'job.job_salary_detail_attributes.currency_id')} {...(props.disabled && { disabled: true })}>{props.currencySymbol}</span> }
              <Select
                  defaultMenuIsOpen =    {props.defaultMenuIsOpen}
                  autoFocus         =    {props.autoFocus}
                  menuIsOpen        =    {props.menuIsOpen}
                  className         =   { props.style != undefined ? SelectStyle.Form__ErrorCustomSelect : defaultClass }
                  classNamePrefix   =   "customSelect"
                  defaultValue      =   { props.default != '' ? props.options ? getSelectedItem(props.default, props.options) : '' : '' }
                  instanceId        =   { props.name }
                  name              =   { props.name }
                  onChange          =   { props.onChange }
                  options           =   { props.options}
                  components        =   {{ DropdownIndicator, ...props.components }}
                  isDisabled        =   { props.disabled}
                  placeholder       =   { props.placeholder || TRANSLATION('placeholder:select:please')}
                  ref               =   { props.reference }
                  styles            =   {{ menu: provided => ({ ...provided, zIndex: 999999 }) }}
                  menuPlacement     =   'auto'
                  value             =   { props.value }
                  isClearable       =   {props.isClearable || false}
                  noOptionsMessage  =   {() => TRANSLATION('placeholder:select:no_options')}
                  isMulti           =   {props.isMulti || false}
                  {...(props.selectProps ? props.selectProps : {})}
                />

                {props.noError ? "" :
                  props.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '', props.custom_error_90 || '')
                                           :  infoPlaceholderSection(props.infoPlaceholder, FormStyle)
                }
            </div>
          )
}


export function getSelectedItem(defaultValue, select_options){
  if(typeof defaultValue === 'string' || typeof defaultValue === 'number'){
    return select_options[GetIndexOfSelectFromValues(select_options, defaultValue)]
  }
  else if(typeof defaultValue === 'object' && defaultValue)
  {
    return select_options[GetIndexOfHashSelectFromValues(select_options, defaultValue)]
  }

}

export function GetIndexOfSelectFromValues(select_options, value)
{
   for ( let index in select_options)
   {
      if(select_options[index].value == value)
      {
        return index;
      }
   }
}

export function GetIndexOfHashSelectFromValues(select_options, value)
{
   for ( let index in select_options)
   {
      if(select_options[index].value == value.integration_id && select_options[index].type == value.integration_type)
      {
        return index;
      }
   }
}